import { htmlToText } from "html-to-text";

/** How CMS rich text is converted to plain text, shared with `stripHtmlForSchema`. */
export const HTML_TO_TEXT_OPTIONS = {
  wordwrap: false as const,
  uppercaseHeadings: false,
  tags: {
    a: {
      options: {
        ignoreHref: true
      }
    }
  }
};

export const stripHtmlString = (html: string): string => {
  const characterSize = 300;

  const newText = htmlToText(html, HTML_TO_TEXT_OPTIONS);

  return newText.substring(0, characterSize);
};
